import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";
import Select from "react-select";

export default class HcsSelect extends HcsCaptionControl {
    constructor(props) {
        super(props);

        // Reference to selectmenu instance
        this.selRef = React.createRef();

        this.state = {
            currentValue: props.data.info.value
        };

        this.valueChanged = this.valueChanged.bind(this);
        this.getCcaoData = this.getCcaoData.bind(this);
        this.handleContainerScroll = this.handleContainerScroll.bind(this);
    }

    valueChanged(selectedItem) {
        let self = this;

        const { data } = this.props;

        if(data.info.value !== selectedItem.value) {
            this.props.checkValueChange(this, {
                confirmed: _ => {
                    self.setState({
                        currentValue: selectedItem.value
                    });

                    self.props.onConfig("setCfgValue", data.ident, selectedItem.value, {
                        sender: "HCS_SELECT",
                        success: _ => {
                            super.triggerConfigurator();
                        }
                    });
                },
                rejected: _ => {
                    let selOption = data.values.filter(item => item.ident === data.info.value).map(item => {
                        return {
                            value: item.ident,
                            label: item.info.trans
                        };
                    });

                    self.selRef.current.select.setValue(selOption[0]);
                }
            });
        }
    }

    // override from base class
    childClass() {
        return "hcs-select";
    }

    // override from base class
    getCcaoData() {
		const { data } = this.props;

        if(data.info.value !== "") {
            let value = data.values.find(value => {
                return value.ident === data.info.value;
            });

            if(value && value.data.CCAO_DATA) {
                try {
                    return JSON.parse(value.data.CCAO_DATA);
                } catch(e) {
                    console.error(`Error parsing CCAO_DATA object from ECS for attribute '${data.ident}' with value '${data.info.value}': ${e.message}: ${value.data.CCAO_DATA}`);
                }
            }
        }

		return null;
    }

    handleContainerScroll(event) {
        const { hcs } = this.props;

        // Fixed buggy scroll behavior or config container.
        // Scrolling did not work when dragging the scrollbar.
        if(!hcs.api.instance(".hcs-wrapper .select__menu")) {
            return;
        }

        // Close selectmenu when scrolling the main config container or body,
        // but keep open when scrolling the menu itself.
        return event.target && (
            event.target === document ||
            event.target.classList && event.target.classList.contains("hcs-wrapper")
        );
    }

    menuFocus(event, gainFocus) {
        let menu = event.target.parentElement.parentElement.parentElement;

        // When selectmenu gains focus we must pass a focus class to the menu/list element as well.
        // Otherwise we don't have the possibility to change the focus style of the list because only the select button itself
        // has a factory focus class.
        if(gainFocus) {
            menu.classList.add("hcs-focused");
        } else {
            menu.classList.remove("hcs-focused");
        }
    }

    render() {
        let self = this;

        const { hcs, data } = this.props;

        const options = data.values.filter(item => item.info.visible).map((item, index) => {
            return {
                value: item.ident,
                label: item.info.trans,
                cfgSuggest: (item.flags && item.flags.CFGSuggest) ? item.flags.CFGSuggest : null
            };
        });

        const currentOption = options.find(o => o.value === data.info.value);

        return super.render(
            <Select
                key={data.ident + "_" + (currentOption ? currentOption.value : "")}
                ref={this.selRef}
                disabled={!super.isEnabled()}
                options={options}
                scrollToFocusedOptionOnUpdate
                defaultValue={currentOption ? currentOption : null}
                onChange={this.valueChanged}
                className={"hcs-select-control hcs-" + data.ident}
                classNamePrefix="select"
                isSearchable={false}
                onFocus={(event) => { this.menuFocus(event, true); }}
                onBlur={(event) => { this.menuFocus(event, false); }}
                closeMenuOnScroll={this.handleContainerScroll}
                menuPlacement="auto"
                menuPosition="fixed"
                placeholder={hcs.t.gui("Selectmenu_PlaceHolder")}
                onMenuOpen={_ => {
                    // Disable scrolling via mousehweel for config area scrollbar.
                    // Otherwise we cannot wheel-scroll in selectmenu.
                    hcs.ui.configScrollbarDisableWheelScroll(true);
                    
                    setTimeout(_ => {
                        // Add custom styling for recommended options
                        // see https://app.asana.com/0/1153937028926678/1193638900039624/f
                        let optionElements = document.querySelectorAll(".hcs-" + data.ident + " .select__menu-list .select__option");
                        
                        if(optionElements) {
                            optionElements.forEach((option, index) => {
                                let optCfg = options[index];

                                if(optCfg.cfgSuggest) {
                                    // We must set a single attribute for CSS because adding class names will be overridden after hovering.
                                    option.setAttribute(optCfg.cfgSuggest, optCfg.cfgSuggest);
                                }
                            });
                        }

                        // Scroll current selected option into view
                        // see: https://app.asana.com/0/790817394557022/1168181192825819/f
                        self.selRef.current.select.scrollToFocusedOptionOnUpdate = true;
                        self.selRef.current.select.setState({
                            focusedOption: options.find(option => currentOption && option.value === currentOption.value)
                        });
                    }, 0);
                }}
                onMenuClose={_ => { hcs.ui.configScrollbarDisableWheelScroll(false); }}
            />
        );
    }
}